const BACKEND_SERVER = "http://82.165.241.59:5000";

export default class Database {
  static async getStationTypeData(station, type, startDate, endDate) {
    const request = await fetch(`${BACKEND_SERVER}/station/${station}/${type}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dateStart: startDate.format("YYYY-MM-DD HH:mm:ss"),
        dateEnd: endDate.format("YYYY-MM-DD HH:mm:ss")
      })
    });

    return await request.json();
  }

  static async getStationData(station, startDate, endDate) {
    const request = await fetch(`${BACKEND_SERVER}/station/${station}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dateStart: startDate.format("YYYY-MM-DD HH:mm:ss"),
        dateEnd: endDate.format("YYYY-MM-DD HH:mm:ss")
      })
    });

    return await request.json();
  }
  
  static async export(startDate, endDate, stations) {
    const request = await fetch(`${BACKEND_SERVER}/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        dateStart: startDate.format("YYYY-MM-DD HH:mm:ss"),
        dateEnd: endDate.format("YYYY-MM-DD HH:mm:ss"),
        stations: stations
      })
    });

    const blob = await request.blob();
    let link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'export.txt');
    link.click();
  }
};